/**
 * 高级搜索-添加搜索字段
 */
import React, { Component } from "react";
import { Checkbox, Input, Icon, Modal,message } from "antd";
import isEqual from "lodash/isEqual";
import debounce from "lodash/debounce";
import classNames from "classnames";
import { Scrollbars } from "react-custom-scrollbars";

let currentLine = 0;

class AddFieldsModal extends Component {
	static defaultProps = {
		visible: false,
		width: 900, // 默认模态框宽度900
		title: "添加搜索字段",
		data: [], // 可供添加的字段列表
		colNum: 6 // 默认一行显示6列
	};

	constructor(props) {
		super(props);
		this.listID = "fields-" + Math.random().toString(36);
		this.state = {
			searchValue: "", // 搜索字段
			checkedList: this.props.checkedList || [], // 选中项
			indeterminate: false, // 控制全选样式状态
			checkAll: false // 是否全选
		};
		this.debounceSearch = debounce(this.debounceSearch, 500);
	}

	componentWillReceiveProps(nextProps) {
		if (
			"checkedList" in nextProps &&
			!isEqual(nextProps.checkedList, this.props.checkedList)
		) {
			const { checkedList, data } = nextProps;
			this.setState({
				checkedList: checkedList,
				checkAll: checkedList.length === data.length,
				indeterminate:
					!!checkedList.length && checkedList.length < data.length
			});
		}
	}

	debounceSearch = value => {
		this.setState({ searchValue: value }, () => {
			this.changeItem();
		});
		// 搜索字段为空，重置currentLine
		if (value == "") {
			currentLine = 0;
		}
	};

	// 搜索
	handleSearchChange = e => {
		const { value } = e.target;
		this.debounceSearch(value);
	};

	// 单个选择
	onChange = checkedList => {
		const { data } = this.props;
		this.setState({
			checkedList,
			indeterminate:
				!!checkedList.length && checkedList.length < data.length,
			checkAll: checkedList.length === data.length
		});
	};

	// 全选
	onCheckAllChange = e => {
		const { data } = this.props;
		this.setState({
			checkedList: e.target.checked ? data.map(item => item.dataIndex) : [],
			indeterminate: false,
			checkAll: e.target.checked
		});
	};

	// 保存
	handleOk = () => {
		const { data, onOk } = this.props;
		const { checkedList } = this.state;
		if (!checkedList || checkedList.length < 1) {
			message.info('请至少选择一个字段');
			return;
		}
		let result = []
		data.forEach(item => {
			if (checkedList.includes(item.dataIndex)) {
				let nitem = {...item}
				nitem.defaultSearch = true;
				result.push(nitem);
			}
		});
		onOk && onOk(result);
	};

	handleCancel = () => {
		const { onCancel } = this.props;
		this.setState({
			searchValue: ""
		});
		onCancel && onCancel();
	};

	handleKeyUp = e => {
		// Enter键盘事件
		if (e.keyCode == 13) {
			this.changeItem();
		}
	};

	// Enter键切换高亮
	changeItem = () => {
		const elements = document
			.getElementById(`${this.listID}`)
			.getElementsByClassName("textHighLight");
		if (elements.length) {
			// 最后一个高亮
			if (currentLine === elements.length) {
				currentLine = 0;
			}
			// 清除高亮
			for (let index = 0; index < elements.length; index++) {
				const element = elements[index];
				element.classList.remove("active");
			}
			// 添加高亮
			elements[currentLine].classList.add("active");
			// currentLine + 1
			currentLine++;
		}
	};

	render() {
		const {
			wrapClassName,
			visible,
			width,
			title,
			data,
			colNum,
			onCancel
		} = this.props;
		const {
			searchValue,
			indeterminate,
			checkAll,
			checkedList
		} = this.state;
		const reg = new RegExp(searchValue, "ig");
		return (
			<Modal
				wrapClassName={classNames(
					wrapClassName,
					"addSearchFieldsModal"
				)}
				width={width}
				title={title}
				okText="保存"
				visible={visible}
				onCancel={this.handleCancel}
				onOk={this.handleOk}
			>
				<div className="searchBox">
					<Input
						placeholder="搜索字段"
						prefix={
							<Icon type="search" style={{ color: "#999" }} />
						}
						onChange={this.handleSearchChange}
						onKeyUp={this.handleKeyUp}
						style={{ width: 280 }}
					/>
				</div>
				<div className="checkAllBox">
					<Checkbox
						indeterminate={indeterminate}
						onChange={this.onCheckAllChange}
						checked={checkAll}
					>
						<b>全选</b>
					</Checkbox>
					<span className="tip">
						已选择：
						<span className="num">{checkedList.length}</span>
					</span>
				</div>
				<Scrollbars style={{ height: 300 }} autoHide>
					<Checkbox.Group
						style={{ width: "100%" }}
						value={checkedList}
						onChange={this.onChange}
					>
						<table id={this.listID}>
							<tbody>
								{data.map((row, i) => {
									if (i % colNum === 0) {
										return (
											<tr key={i}>
												{data
													.slice(
														i,
														i % colNum === 0
															? i + colNum
															: i % colNum
													)
													.map((item, j) => {
														let _label = item.title;
														// 对label做高亮匹配
														if (searchValue) {
															const match =
																(_label &&
																	_label.match(
																		reg
																	)) ||
																[];
															_label =
																_label &&
																_label
																	.split(reg)
																	.map(
																		(
																			_it,
																			_idx
																		) =>
																			_idx >
																			0
																				? [
																						<span
																							key={
																								_idx
																							}
																							className="textHighLight"
																						>
																							{
																								match[0]
																							}
																						</span>,
																						_it
																				  ]
																				: _it
																	);
														}
														return (
															<td key={j}>
																<Checkbox
																	value={
																		item.dataIndex
																	}
																>
																	{_label}
																</Checkbox>
															</td>
														);
													})}
											</tr>
										);
									} else {
										return null;
									}
								})}
							</tbody>
						</table>
					</Checkbox.Group>
				</Scrollbars>
				<style jsx="true" global="true">
                        {`
                            .addSearchFieldsModal .searchBox{
								margin-bottom: 16px;
							}
							.addSearchFieldsModal .checkAllBox{
								margin: 0 0 8px 9px;
								font-size: 12px;
							}
							.addSearchFieldsModal .checkAllBox .tip{
								color: #bbb;
							}
							.addSearchFieldsModal .checkAllBox .num{
								color: #fc0;
							}
							.addSearchFieldsModal table{
								width: 100%;
								border: 1px solid #e8e8e8;
								border-right: 0;
								border-bottom: 0;
								border-radius: 4px 4px 0 0;
								border-collapse: separate;
								border-spacing: 0;
							}
							.addSearchFieldsModal  table  td{
								border-right: 1px solid #e8e8e8;
								border-bottom: 1px solid #e8e8e8;
								font-size: 12px;
							}
							.addSearchFieldsModal  table  td:hover{
								background-color: #eef7fe;
							}
							.addSearchFieldsModal  table  .ant-checkbox-wrapper{
								width: 100%;
								height: 100%;
								padding: 6px 8px;
							}
							.addSearchFieldsModal .textHighLight{
								background-color: #fff5cc;
							}
							.addSearchFieldsModal .textHighLight .active{
								background-color: #ffdc52;
							}
                        `}
                    </style>
			</Modal>
		);
	}
}

export default AddFieldsModal;



// WEBPACK FOOTER //
// ./components/common/NHTable/AddFieldsModal.js